<div [formGroup]="form">
  <!-- Row 1: Region, Policy Number, Product Category & Product -->
  <div class="row">
    <div class="col-md-3">
      <div class="form-group mb-3">
        <label for="policyNumber" class="form-label">{{
          labels.policyNumber
        }}</label>
        <div class="policy-number-wrapper">
          <input
            type="text"
            id="policyNumber"
            class="form-control policy-number-input"
            [class.masked-policy-number]="lang === 'en-us' && !showPolicyNumber"
            formControlName="policyNumber"
            placeholder="{{ placeholders.enterPolicyNumber }}"
            maxlength="100"
            autocomplete="off"
          />
          <button
            *ngIf="lang === 'en-us'"
            type="button"
            class="policy-number-toggle"
            (click)="togglePolicyNumberVisibility()"
            [attr.aria-label]="showPolicyNumber ? 'Hide policy number' : 'Show policy number'"
            [attr.title]="showPolicyNumber ? 'Hide' : 'Show'"
          >
            <i class="fas" [ngClass]="showPolicyNumber ? 'fa-eye-slash' : 'fa-eye'"></i>
          </button>
        </div>
      </div>
    </div>

    <app-product-category-fields [form]="form" [lang]="lang" columnClass="col-md-3"></app-product-category-fields>

    <div class="col-md-3" *ngIf="lang === 'en'">
      <div class="form-group mb-3">
        <label for="region" class="form-label"
          >Region <span class="ast">*</span></label
        >
        <select
          id="region"
          class="form-control"
          formControlName="region"
          [class.is-invalid]="isFieldInvalid('region')"
        >
          <option value="" disabled selected>Select a region</option>
          <option value="UK">UK</option>
          <option value="EU">EU</option>
          <option value="INT">Rest of world</option>
        </select>
        <div class="invalid-feedback" *ngIf="isFieldInvalid('region')">
          {{ messages.fieldRequired }}
        </div>
      </div>
    </div>
  </div>

  <!-- Row 2: Description -->
  <div class="row">
    <div class="col-md-12">
      <div class="form-group mb-3">
        <label for="description" class="form-label"
          >{{ labels.describeRequest }} <span class="ast">*</span></label
        >
        <textarea
          id="description"
          class="form-control"
          formControlName="description"
          [class.is-invalid]="isFieldInvalid('description')"
          rows="4"
          placeholder="{{ placeholders.describeYourRequest }}"
          maxlength="2000"
        ></textarea>
        <div class="invalid-feedback" *ngIf="isFieldInvalid('description')">
          <span *ngIf="form.get('description')?.hasError('required')">
            {{ messages.fieldRequired }}
          </span>
          <span *ngIf="form.get('description')?.hasError('minlength')">
            {{ messages.characterLimit }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
